import types from '../../config/types.js'
import MockServer from './MockServer.js'
import MockPagination from './MockPagination.js'
import MockAccessRules from './MockAccessRules.js'

export default {
  mixins: [MockServer, MockAccessRules, MockPagination],
  data() {
    return {
      // filePopup: {
      //   file: null,
      //   opened: false,
      // },
      searchTimeOut: null,
      filtersData: {
        page: 1,
        per_page: 10,
        order: 'unit_name',
        order_type: 'asc',
      },
      disconnectConfirmOpened: false,
    }
  },
  computed: {
    currentGate() {
      return this.$store.getters.currentGate
    },
    filters() {
      return [
        {
          id: 'search',
          type: types.components.input,
          width: 4,
          attr: {
            placeholder: 'Поиск',
          },
        },
        {
          id: 'status',
          type: types.components.select,
          width: 1,
          attr: {
            placeholder: 'Статус',
            options: [
              {
                id: true,
                label: 'Верифицирован',
              },
              {
                id: false,
                label: 'Не верифицирован',
              },
            ],
          },
        },
      ]
    },
    tableColumns() {
      return [
        {
          id: 'flat',
          label: '№',
          onclick: () => {
            this.filtersData.order = 'unit_name'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredContacts()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'unit_name',
          style: {
            minWidth: '130px',
          },
        },
        {
          id: 'section',
          label: 'Подъезд',
          onclick: () => {
            this.filtersData.order = 'section'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredContacts()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'section',
        },
        {
          id: 'unit_type',
          label: 'Тип помещения',
          onclick: () => {
            this.filtersData.order = 'unit_type'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredContacts()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'unit_type',
          style: {
            minWidth: '130px',
          },
        },
        {
          id: 'phone',
          label: 'Телефон',
          onclick: () => {
            this.filtersData.order = 'phone'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredContacts()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'phone',
        },
        {
          id: 'name',
          label: 'ФИО',
          onclick: () => {
            this.filtersData.order = 'name'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredContacts()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'name',
        },
        {
          id: 'sigur_rules',
          label: 'Доступы (из Сервера)',
          component: {
            type: 'link',
          },
          onclick: () => {
            this.filtersData.order = 'sigur_rules'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredContacts()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'sigur_rules',
          style: {
            minWidth: '220px',
          },
        },
        {
          id: 'status',
          component: {
            type: 'switcher',
            'label-true': 'Верифицирован',
            'label-false': 'Не верифицирован',
          },
          label: 'Статус верификации',
          onclick: () => {
            this.filtersData.order = 'status'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredContacts()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'status',
          style: {
            minWidth: '263px',
          },
        },
      ]
    },
    tableRows() {
      const data = []

      this.contactList.forEach(contact => {
        data.push({
          id: contact.uid,
          columns: [
            {
              id: 'address',
              content: {
                id: contact.uid,
                label: contact.sigur_server_contact_config.property.address,
              },
            },
            {
              id: 'flat',
              content: {
                id: contact.uid,
                label: contact.unit_name,
              },
            },
            {
              id: 'unit_type',
              content: {
                id: contact.uid,
                label: this.getUnitTypeLabel(contact.unit_type),
              },
            },
            {
              id: 'section',
              content: {
                id: contact.uid,
                label: contact.section ?? '-',
              },
            },
            {
              id: 'name',
              content: {
                id: contact.uid,
                label: contact.user?.name,
              },
            },
            {
              id: 'phone',
              content: {
                id: contact.uid,
                label: contact.user?.phone,
              },
            },
            {
              id: 'sigur_rules',
              content: {
                id: contact.uid,
                label: this.getContactRules(contact),
              },
            },
            {
              id: 'status',
              content: {
                id: contact.uid,
                label: contact.is_verified,
              },
            },
          ],
        })
      })

      return data
    },
    actions() {
      return {
        default: [
          {
            id: 1,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              label: 'Настроить пропуска',
              icon: 'edit',
              handler: () =>
                this.$router.push({
                  name: 'ResidentPassEdit',
                  params: { gateId: this.$route.params.gateId },
                }),
            },
          },
          // {
          //   id: 2,
          //   type: types.actions.button,
          //   attr: {
          //     type: "secondary",
          //     label: "Добавить абонентов через файл",
          //     icon: "upload-file",
          //     handler: () => {
          //       this.filePopup.opened = true;
          //     },
          //   },
          // },
          {
            id: 3,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              colored: 'danger',
              label: 'Отключить адрес',
              icon: 'trash',
              handler: () => this.openDisconnectConfirm(),
            },
          },
        ],

        selected: [
          {
            id: 1,
            type: types.actions.text,
            label: `Выбрано элементов: ${this.rowsSelected.length}`,
          },
          {
            id: 2,
            type: types.actions.button,
            attr: {
              type: 'primary',
              label: 'Верифицировать',
              icon: 'check',
              handler: () => this.verifySelectedContacts(true),
            },
          },
          {
            id: 3,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              label: 'Отменить верификацию',
              icon: 'check',
              handler: () => this.verifySelectedContacts(false),
            },
          },
          {
            id: 4,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              label: 'Снять выделение',
              icon: 'cross',
              handler: () => (this.rowsSelected = []),
            },
          },
          // {
          //   id: 4,
          //   type: types.actions.button,
          //   attr: {
          //     type: "secondary",
          //     colored: "danger",
          //     label: "Удалить строку",
          //     icon: "trash",
          //     handler: () => this.deleteContacts(),
          //   },
          // },
        ],
      }
    },
    currentAddress() {
      return this.$store.getters.currentAddress
    },
    currentServer() {
      return this.$store.getters.currentServer
    },
  },
  methods: {
    onSwitcherClick({ row, column, currentValue }) {
      this.verifyContact(row, !currentValue)
    },
    getUnitTypeLabel(unitType) {
      const unitTypeMap = {
        flat: 'Квартира',
        parking: 'Паркинг',
        commercial: 'Коммерческое помещение',
        warehouse: 'Кладовая',
        apartment: 'Апартаменты',
      }

      return unitTypeMap[unitType] || unitType
    },
    toggleColumnOrderType(column) {
      this.filtersData.order_type =
        this.filtersData.order === column &&
        this.filtersData.order_type === 'asc'
          ? 'desc'
          : 'asc'
    },

    // onFilePopupClose() {
    //   this.filePopup.opened = false;
    // },
    // onFilePopupApprove() {
    //   this.gateService.addContacts(this.currentGate.cuid, {
    //     contactsFile: this.filePopup.file
    //   }).then(response => {
    //     this.getCurrentGateContacts();

    //     this.filePopup.opened = false;
    //   }).catch(error => {
    //     console.log(error)
    //   })

    // },
    verifySelectedContacts(status) {
      this.$store.dispatch('setIsLoading', true)
      let data = { contacts: [], status: status }
      this.rowsSelected.forEach(value => {
        data.contacts.push({ id: value })
      })
      this.contactService
        .verifyContacts(data)
        .then(async response => {
          this.rowsSelected = []
          await this.getCurrentGateContacts()
          this.$store.dispatch('setIsLoading', false)
        })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('setIsLoading', false)
        })
    },
    verifyContact(contactId, status) {
      this.$store.dispatch('setIsLoading', true)
      this.contactService
        .verifyContacts({ contacts: [{ id: contactId }], status: status })
        .then(async response => {
          await this.getCurrentGateContacts()
          this.$store.dispatch('setIsLoading', false)
        })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('setIsLoading', false)
        })
    },
    openDisconnectConfirm() {
      this.disconnectConfirmOpened = true
    },
    onDisconnectConfirmClose() {
      this.disconnectConfirmOpened = false
    },
    onDisconnectConfirmApprove() {
      this.$store.dispatch('setIsLoading', true)
      this.deleteGate(this.$route.params.gateId)
    },
    deleteGate(gateId) {
      this.gateService
        .removeGates([gateId])
        .then(async response => {
          this.disconnectConfirmOpened = false
          this.$store.dispatch('setIsLoading', false)
          this.$router.push({ name: 'Gates' })
        })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('setIsLoading', false)
        })
    },
    deleteContacts() {
      this.contactService
        .removeContacts(this.rowsSelected)
        .then(async response => {
          await this.getCurrentGateContacts()
        })
        .catch(error => {
          console.log(error)
        })
    },
    filterContacts(filters) {
      if (this.searchTimeOut) {
        clearTimeout(this.searchTimeOut)
      }

      this.searchTimeOut = setTimeout(() => {
        filters.organizationId = this.currentOrganizationId
        filters.sigurServerContactConfigId = this.$route.params.gateId
        this.filtersData = { ...this.filtersData, ...filters, page: 1 }

        this.getFilteredContacts()
      }, 500)
    },
    async getCurrentGateContacts() {
      this.filtersData.organizationId = this.currentOrganizationId
      this.filtersData.sigurServerContactConfigId = this.$route.params.gateId

      await this.getFilteredContacts()
    },
    setContactsPagination() {
      this.initPagination(
        this.contactsMeta.current_page,
        this.contactsMeta.total,
        this.contactsMeta.per_page
      )
    },
    async getFilteredContacts() {
      await this.getContacts(this.filtersData)
      this.setContactsPagination()
    },
    onSwitchPage(page) {
      this.filtersData.page = page
      this.getFilteredContacts()
    },
  },
  async created() {
    // this.$store.dispatch('setIsLoading', true)
    // this.filtersData.order = 'unit_name'
    // this.filtersData.order_type = 'asc'
    // if (this.serverList.length === 0) {
    //   this.getServers({
    //     organizationId: this.currentOrganizationId,
    //   })
    // }
    // if (this.propertyList.length === 0) {
    //   this.getProperties({
    //     organizationId: this.currentOrganizationId,
    //   })
    // }
    await this.getCurrentGateContacts()

    if (this.currentServer) {
      if (!this.serverRules[this.currentServer.suid]) {
        const response = await this.getAccessRules(this.currentServer.suid)
        this.setClientPopupOptions(response.data)
      } else {
        this.setClientPopupOptions(this.serverRules[this.currentServer.suid])
      }
    }
  },
}
